import { render, staticRenderFns } from "./PermissionEdit.vue?vue&type=template&id=476d010a&scoped=true&"
import script from "./PermissionEdit.vue?vue&type=script&lang=js&"
export * from "./PermissionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d010a",
  null
  
)

export default component.exports